import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "store/hooks";
import { getGrade } from "store/slices/user";

import { useWeeksCount } from "utils/hooks/useWeeksCount";

const CalendarWeeksLeft = () => {
  const { t } = useTranslation(["common"]);
  const { weeksCount } = useWeeksCount();
  const grade = useAppSelector(getGrade);
  const isGraduate = grade === "maturant";

  return (
    <div className="calendar-weeks-left">
      <div>
        {t("menu.weeksLeft", { context: isGraduate ? "graduate" : undefined })}:
        <span className={`streak streak--calendar`}>
          <span className="streak__content">
            <span className="streak__icon">
              <Image src={"/images/30-calendar-D-day.svg"} loading={"eager"} />
            </span>
            <span className="streak__badge streak__badge--rounded">{weeksCount}</span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default CalendarWeeksLeft;
